<template>
  <div class="modal-wrapper" v-if="amountToTransferLoaded">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="emitCloseModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            <strong>#{{ selectedRecipient.id }}</strong> Tranferência manual
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <div class="modal-body__field">
            <h3>Recebedor</h3>
            <input-field
              label="Documento"
              v-model="selectedRecipient.document_formatted"
              :disabled="true"
            />
            <input-field
              label="ID PagarMe"
              v-model="selectedRecipient.psp_data.pagarme_recipient_id"
              :disabled="true"
            />
            <money-field
              label="Valor para transferir"
              v-model="recipientForm.get('amountToTransfer').value"
              :errors="recipientForm.get('amountToTransfer').errors"
              @input="recipientForm.get('amountToTransfer').validateField()"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="submitTransfer">
            Transferir
          </button>
          <button class="btn btn-default" @click="emitCloseModal">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputField, MoneyField } from 'components/form';
import RecipientsService from 'services/RecipientsService';
import { FormGroup } from 'utils/form';

export default {
  components: {
    InputField,
    MoneyField,
  },
  data() {
    return {
      amountToTransferLoaded: false,
      recipientForm: new FormGroup({
        amountToTransfer: { required: true, greaterThanOrEqualTo: 0 },
      }),
    };
  },
  mounted() {
    this.reloadAmountToTransfer();
  },
  computed: {
    ...mapState([
      'institution',
      'selectedRecipient',
    ]),
  },
  methods: {
    reloadAmountToTransfer() {
      RecipientsService.reloadRecipientAmount(this.selectedRecipient.id).then((data) => {
        this.recipientForm.addValues({ amountToTransfer: (data.psp_data.pagarme_available_value / 100.0) || 0 });
        this.amountToTransferLoaded = true;
      }).catch(() => {
        this.$alert.notifyAlert('Erro ao atualizar saldo');
        this.emitCloseModal();
      });
    },
    clearInputError() {
      this.inputError = null;
    },
    emitCloseModal() {
      this.$emit('close');
    },
    submitTransfer() {
      RecipientsService.createManualTransfer(this.selectedRecipient.id, this.recipientForm.getRawValue())
        .then(() => {
          this.emitCloseModal();
          this.$alert.notifySuccess('Transferência feita com sucesso');
        }).catch(() => {
          this.emitCloseModal();
          this.$alert.notifyAlert('Erro ao criar transferência');
        });
    },
  },
};
</script>
